import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface FooterProps {
  variant?: 'default' | 'minimal';
  /** `onPhoto`: light text for a dark photo backdrop */
  tone?: 'default' | 'onPhoto';
  className?: string;
}

export default function Footer({ variant = 'default', tone = 'default', className = '' }: FooterProps) {
  const currentYear = new Date().getFullYear();
  const onPhoto = tone === 'onPhoto';

  return (
    <footer
      className={cn(
        'relative z-10 py-8 border-t backdrop-blur-sm',
        onPhoto ? 'border-white/20' : 'border-border/20',
        className
      )}
    >
      <div className={cn('container mx-auto px-4 text-center', onPhoto ? 'text-white/80' : 'text-muted-foreground')}>
        <p className="text-sm">
          © {currentYear} Casa Aragón. Todos los derechos reservados.
        </p>
        {variant === 'default' && (
          <div className="flex flex-wrap items-center justify-center gap-3 mt-3 text-xs">
            <Link
              to="/privacidad"
              className={cn(
                'transition-colors underline-offset-4 hover:underline',
                onPhoto ? 'hover:text-white' : 'hover:text-foreground'
              )}
            >
              Política de Privacidad
            </Link>
          </div>
        )}
      </div>
    </footer>
  );
}
